






















































import companyType from '@/store/types/company';
import { NemiPayNotifications } from '@/util/nemiPayNotifications';
import commissions from '@/components/Company/newCompany/companyInfo/forms/commissions.vue';
import {
  CompanyParams,
  EnterpriceAddress,
  EnterpriceCommissions,
  EnterpriceData,
  EnterpriceBankData
} from '@/store/interfaces/company';
import root from '@/store/types/root';
import copyObj from '@/util/copyObj';
import { IObjectKeys } from '@/store/interfaces/generic';
import enterpriseData from '@/components/Company/newCompany/companyInfo/enterpriseData.vue';
import enterpriseAddress from '@/components/Company/newCompany/companyInfo/enterpriseAddress.vue';
import enterpriseBankData from '@/components/Company/newCompany/companyInfo/enterpriseBankData.vue';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import { dayjsUTC } from '@/util/classes/datesFormat';

export default Vue.extend({
  name: 'ProfileCompanyUpdateCompany',
  components: {
    commissions,
    enterpriseData,
    enterpriseAddress,
    enterpriseBankData,
  },

  data: () => ({
    loading: true,
    company: {
      id: '',
      business_name: '',
      liquidation_kind_id: '',
      membership_status: 'inactive',
      membership_validation: 'no',
      branches_count: 0,
      billing_comment: '',
      address: {
        country_code: '',
        description: '',
        phone: '',
        state_code: '',
      },
      artificial_person: false,
      company_profile_id: '',
      state_code: '',
      country_name: '',
      taxpayer_type: 'non',
      contacts: [],
      bank_account: {
        account_number: '',
        account_type: 'current',
        bank_id: '',
        id: '',
        name: '',
        billing_type: 'final_consumer',
        account_holder: '',
        billing_address: '',
        contact: {
          email: '',
          id: '',
          name: '',
          phone: '',
          phone2: '',
        },
        contact_id: '',
      },
      commission: {
        rate: 0,
        start_at: '',
        liquidation_period: '',
        minimum_order_value: 0,
        renewal: 'automatic',
        fixed_fee_cents: 0,
        fixed_fee_currency: 'USD',
      },
      company_bank_account: {
        bank_name: '',
        bank_address: '',
        account_number: '',
        account_holder: '',
        aba_routing_number: '',
        swift_code: '',
        corresponsal_information: '',
        notes: '',
        payment_type: '',
      },
      commerces_count: 2,
      created_at: '2021-03-10T20:18:56Z',
      business_turn: 'company',
      company_profile: null,
      intermediary_id: '',
      name: 'company',
      intermediary: null,
      fixed_withholding: false,
      business_activity_summary: null,
    } as CompanyParams,
  }),
  computed: {
    ...mapGetters({
      getSingleCompany: `companyModule/${companyType.getters.GET_SINGLE_COMPANY}`,
      getProcess: root.getters.GET_START_PROCESS,
    }),
    modelEnterpriseAddress: {
      get() {
        const company = this.getSingleCompany;
        if (company.address) {
          return {
            state_code: company.address.state_code,
            country_code: company.address.country_code,
            description: company.address.description,
            phone: company.address.phone,
          };
        } else {
          return {
            state_code: '',
            description: '',
            phone: '',
          };
        }
      },
      set(model: EnterpriceAddress) {
        this.company.address = {
          ...this.company.address,
          ...model,
        };
        this.company.state_code = model.state_code;
      },
    },
    modelEnterpriseData: {
      get() {
        const company = this.getSingleCompany;
        return {
          business_name: company.business_name || '',
          artificial_person: company.artificial_person,
          membership_status: company.membership_status,
          membership_validation: company.membership_validation,
          taxpayer_type: company.taxpayer_type,
          state_code: company.state_code,
          business_turn: company.business_turn,
          liquidation_kind_id: company.liquidation_kind_id || '',
          company_profile_id: company.company_profile?.id || '',
          fixed_withholding: company.fixed_withholding || false,
          business_activity_summary: company.business_activity_summary || '',
          intermediary_id: company.intermediary_id || '',
          name: company.name,
          billing_comment: company.billing_comment || '',
        };
      },
      set(model: EnterpriceData) {
        this.company = {
          ...this.company,
          ...model,
        };
      },
    },
    modelEnterpriseBankData: {
      get() {
        const company = this.getSingleCompany;
        const bank = company.company_bank_account || {};
        return {
          bank_name: bank.bank_name || '',
          bank_address: bank.bank_address || '',
          account_number: bank.account_number || '',
          account_holder: bank.account_holder || '',
          aba_routing_number: bank.aba_routing_number || '',
          swift_code: bank.swift_code || '',
          corresponsal_information: bank.corresponsal_information || '',
          notes: bank.notes || '',
          payment_type: bank.payment_type || '',
          blockchain: bank.blockchain || '',
          wallet_address: bank.wallet_address || '',
          confirm_wallet_address: bank.wallet_address || '',
        };
      },
      set(model: EnterpriceBankData) {
        this.company.company_bank_account = {
          ...this.company.company_bank_account,
          ...model,
        };
      },
    },
  },
  created() {
    this.company = copyObj(this.getSingleCompany);
    delete this.company.contacts;
    delete this.company.bank_account;
    delete this.company.id;

    // Formats date
    if (this.company.commission) {
      const start_at = this.company.commission.start_at;
      this.company.commission.start_at = dayjsUTC(start_at)
        .format('YYYY-MM-DD');

      this.company.commission.fixed_fee_cents = this.company.commission.fixed_fee_cents / 100;
    }

    this.loading = false;
  },
  methods: {
    ...mapActions({
      updateCompany: `companyModule/${companyType.actions.UPDATE_COMPANY}`,
    }),
    getCommissions(val: EnterpriceCommissions) {
      this.company.commission = val;
    },
    updateProfile() {
      const notificacion = new NemiPayNotifications();
      const companyToUpdate: IObjectKeys = copyObj(this.company);

      if (companyToUpdate.commission && 'fixed_fee_cents' in companyToUpdate.commission) {
        companyToUpdate.commission.fixed_fee_cents = companyToUpdate.commission.fixed_fee_cents * 100;
      }

      const toUpdate = {
        data: companyToUpdate,
        company_id: this.$route.params.company_id,
      };
      this.updateCompany(toUpdate)
        .then(() => {
          notificacion.success('Actualizado correctamente');
          this.$emit('cancel', true);
        })
        .catch(() => {
          notificacion.warning('Algo ha salido mal');
        });
    },
    cancel() {
      this.$emit('cancel', true);
    },
  },
  watch: {
    'company.state_code'(val: string) {
      if (this.company.address) {
        this.company.address.state_code = val;
      }
    },
  },
});

